import { render, staticRenderFns } from "./Created.vue?vue&type=template&id=6dd825b2&"
import script from "./Created.vue?vue&type=script&lang=js&"
export * from "./Created.vue?vue&type=script&lang=js&"
import style0 from "./Created.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports